<template>
  <TaskTypeTable></TaskTypeTable>
</template>

<script>
import TaskTypeTable from 'CORE/components/task/type/table'

export default {
    name: 'TaskTypesTableView',
    components: {
        TaskTypeTable,
    },
}
</script>
